<template lang="pug">
  .main
    //- h2.title(v-if="title") {{title}}
    Tab(
      :tabList="tabList"
      :path="path")
      DataTablePage(
        slot="copyDate"
        ref="copyDateTable"
        mainColumn="day"
        longColumn=""
        title=""
        label="计划任务"
        labelName=""
        :resource="resource"
        :toolbar="toolbar"
        :operation="operation"
        :operationWidth="115"
        :filterFullList="filterFullList"
        :filterInitList="filterInitList"
        :tableData="tableData"
        :tableFullList="tableFullList"
        :tableInitList="tableInitList"
        :createList="createList"
        :updateList="updateList"
        :columns="columns"
        @getRelation="getRelation")
          .col-md-12(slot="formTopSlot")
            .form-group.row
              label.col-form-label.text-sm-right.col-sm-3 配置类型
              .col-sm-9
                .input-group
                  el-switch(
                    v-model="actSwitchVal"
                    ref="settingType"
                    on-text="常规配置"
                    on-color="#df9464"
                    on-value="ordinary"
                    off-text="高级配置"
                    off-color="#409eff"
                    off-value="senior"
                    :width="100"
                    @change="changeSwitch")
      .formBox(slot="freeze")
        SmartForm.freezeForm(
          v-model="freezeValues"
          labelPosition="right"
          btnPosition="center"
          ref="freezeForm"
          :btnLabel="false"
          :formList="freezeFormList"
          :values="freezeValues"
          :columns="columns"
          :buttonList="freezeButtonList"
          :formEnterIndex="0")
</template>
<script>
  // import moment from 'moment'
  import SmartForm from '@/components/SmartForm'
  import DataTablePage from '@/containers/DataTablePage'
  import Tab from '@/components/Tab'
  import columns from './columns.js'
  import {treeFormat} from '@/utils/common.js'
  // import { fetch } from '@/utils/api'
  import { fetch, fetchCreate, fetchUpdate } from '@/utils/api'
  import { cloneDeep } from 'lodash'
  import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
  import { operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
  import { URL } from '@/utils/common'
  import { expire } from '@/utils/auth'
  export default {
    name: 'periodsetting',
    components: {
      DataTablePage,
      SmartForm,
      Tab
    },
    data () {
      let copyDayOptions = []
      let copyDayOptionsSTR = []
      for (let i = 0; i < 31; i++) {
        copyDayOptions.push({ 'label': `${i + 1}号`, 'value': i + 1 })
        copyDayOptionsSTR.push({ 'label': `${i + 1}号`, 'value': `${i + 1}` })
      }
      const resource = '/nb/task'
      const tabList = [{label: '定时任务设置', name: 'copyDate'}, {
        label: '冻结时间设置', name: 'freeze'
      }]
      return {
        title: '计划任务',
        actSwitchVal: 'ordinary',
        refreshValue: 1,
        isRelation: false,
        currentId: null,
        path: '/nb/periodSetting',
        copyDayOptions: [],
        copyDayOptionsSTR: [],
        freezeResource: '/nb/task/copy',
        resource: resource,
        tabList: tabList,
        tabName: this.$route.query.state || tabList[0].name,
        filterInitList: ['operate', 'param'],
        filterFullList: ['operate', 'param'],
        createList: ['day', 'copyTime', 'operate', 'param'], // 默认新建form列表
        updateList: ['day', 'copyTime', 'operate', 'param'], // 默认编辑form列表
        initList: ['day', 'copyTime', 'operate', 'param'], // 常规列表
        advancedList: ['cron', 'operate', 'param'], // 高级列表
        freezeFormList: ['dayTime', 'monthDay', 'monthTime'],
        freezeButtonList: [{
          label: '保存',
          validate: true,
          funcProps: {
            el: this
          },
          func ({funcProps}) {
            const { form, el } = funcProps
            const formValues = {
              ...form.formValues
            }
            fetchUpdate({
              resource: el.freezeResource,
              id: '',
              data: {
                ...formValues
              }
            }).then(res => {
              if (res) el.$swal('保存成功', '', 'success')
            })
          }
        }],
        freezeFormValues: {},
        formValue: {
          operate: '',
          param: [],
          copyTime: '',
          day: [],
          hour: '',
          minute: '',
          second: ''
        },
        createFormValues: {
          operate: '',
          param: [],
          copyTime: '',
          day: [],
          hour: '',
          minute: '',
          second: ''
        },
        tableData: [],
        tableFullList: ['day', 'cron', 'type', 'copyTime', 'operate', 'param'],
        tableInitList: ['day', 'cron', 'type', 'copyTime', 'operate', 'param'],
        dialogVisible: false,
        columns: {
          ...columns,
          type: {
            label: '配置类型',
            type: 'select',
            width: 100,
            filter: {
              type: 'select',
              width: 120
            },
            form: {
              type: 'switch'
            },
            options: [{
              label: '高级配置',
              value: 'senior'
            }, {
              label: '常规配置',
              value: 'ordinary'
            }],
            style: {
              textAlign: 'center'
            }
          },
          day: {
            label: '每月执行日',
            type: 'multiselect',
            form: {
              type: 'select',
              multiple: true,
              live: true,
              rules: [
                { type: 'required', required: true, message: '请选择每月执行日', trigger: 'change' }
              ]
            },
            options: copyDayOptions
          },
          dayTime: {
            label: '日冻结时间',
            type: 'time',
            form: {
              type: 'time',
              dataType: 'number',
              valueFormat: 'HH:mm:ss',
              rules: [{ type: 'required', required: true, message: '请选择日冻结时间', trigger: 'change' }]
            }
          },
          monthDay: {
            label: '月冻结时间',
            type: 'select',
            form: {
              type: 'select',
              labelSize: 6,
              rules: [
                { type: 'required', required: true, message: '请选择月冻结时间', trigger: 'change' }
              ],
              columnSize: [{
                type: 'md',
                size: 6
              }, {
                type: 'sm',
                size: 12
              }]
            },
            options: copyDayOptionsSTR
          },
          monthTime: {
            label: '',
            form: {
              type: 'time',
              dataType: 'number',
              valueFormat: 'HH:mm:ss',
              labelSize: 1,
              rules: [{ type: 'required', required: true, message: '请选择月冻结时间', trigger: 'change' }],
              columnSize: [{
                type: 'md',
                size: 6
              }, {
                type: 'sm',
                size: 12
              }]
            }
          },
          copyTime: {
            label: '执行时间',
            width: 180,
            style: {
              'text-align': 'center'
            },
            form: {
              type: 'time',
              dataType: 'number',
              valueFormat: 'HH:mm:ss',
              // arrowControl: true,
              rules: [{ type: 'required', required: true, message: '请选择执行时间', trigger: 'change' }]
            }
          },
          operate: {
            label: '对应操作',
            type: 'select',
            width: 100,
            relation: 'operate',
            style: {
              'text-align': 'center'
            },
            form: {
              type: 'select',
              rules: [{ type: 'required', required: true, message: '请选择对应操作', trigger: 'change' }]
            },
            filter: {
              type: 'select',
              width: 130
            }
          },
          param: {
            label: '所选区域',
            type: 'multiselect',
            relation: 'areaId',
            form: {
              type: 'tree',
              rules: [{ type: 'required', required: true, message: '请选择所选区域', trigger: 'change' }]
            },
            filter: {
              type: 'cascader',
              onlySelectLeaf: false,
              like: true,
              width: 100
            }
          },
          cron: {
            label: '周期',
            width: 120,
            filter: {
              type: 'input',
              like: true,
              width: 100
            },
            form: {
              type: 'input',
              placeholder: '[秒] [分] [时] [日] [月] [周] [年]|*代表所有|?代表不填',
              rules: [{ type: 'required', required: true, message: '格式: [秒] [分] [时] [日] [月] [周] [年], *代表所有 ?代表不填' }],
              helpHref: `${URL}/help/help_task.docx`,
              help: '查看规则文档'
            }
          }
        },
        operation: [{
          ...operationUpdate,
          funcProps: {
            form: this,
            el: this
          },
          func ({funcProps}) {
            const { table, el, data } = funcProps
            table.dialogLabel = '编辑' + table.label
            table.dialogFormValues = cloneDeep(data)
            table.dialogFormList = table.updateList
            table.dialogButtonList = el.updateButtonList
            table.actSwitchVal = data.type
            console.info(1, data.type)
            el.changeSwitch(data.type)
            table.dialogVisible = true
          }
        }, {
          ...operationDelete
        }],
        toolbar: [{
          ...toolbarCreate,
          validate: true,
          funcProps: {
            form: this,
            el: this
          },
          func ({funcProps}) {
            const { table, el } = funcProps
            table.dialogLabel = '新增' + table.label
            table.dialogFormValues = cloneDeep(el.createFormValues)
            table.dialogFormList = table.createList
            table.dialogButtonList = el.createButtonList
            table.actSwitchVal = 'ordinary'
            // el.changeSwitch(this.actSwitchVal)
            table.dialogVisible = true
          }
        }],
        createButtonList: [{
          name: 'submit',
          label: '新增',
          validate: true,
          funcProps: {
            table: this
          },
          func ({funcProps}) {
            const { form, table, button } = funcProps
            button.loading = true
            let formValues = form.formValues
            const timeArr = formValues.copyTime.split(':')
            const { resource, values: createValues } = table.setRequireParams(table.actSwitchVal, { timeArr, formValues })
            // console.info(formValues, resource, createValues)
            fetchCreate({
              resource: resource,
              data: createValues
            }).then(res => {
              button.loading = false
              if (res) {
                table.$nextTick(() => {
                  const copyDateTable = table.$refs.copyDateTable
                  copyDateTable.getData()
                  copyDateTable.dialogVisible = false
                })
              }
            })
          }
        }],
        updateButtonList: [{
          name: 'submit',
          label: '编辑',
          validate: true,
          funcProps: {
            table: this
          },
          func ({funcProps}, data) {
            const { table, form, button } = funcProps
            button.loading = true
            let formValues = form.formValues
            const timeArr = formValues.copyTime.split(':')
            const { resource, values: updateValues } = table.setRequireParams(table.actSwitchVal, { timeArr, formValues })
            fetchUpdate({
              resource: resource,
              id: form.formValues.id,
              data: updateValues
            }).then(res => {
              button.loading = false
              if (res) {
                table.$nextTick(() => {
                  const copyDateTable = table.$refs.copyDateTable
                  copyDateTable.getData()
                  copyDateTable.dialogVisible = false
                  table.$swal(`${res.message}`, '', 'success')
                  // table.$message({ type: 'success', showClose: true, message: res.message })
                })
              }
            })
          }
        }]
      }
    },
    watch: {
      $route (to, form) {
        this.tabName = to.query.state || this.tabList[0].name
        this.changeTabEvent(to.query.state)
      },
      tabName (value) {
        if (value === 'freeze') {
          this.getFreezeData()
        }
      },
      actSwitchVal (value) {
        console.info(11, value)
        const table = this.$refs.copyDateTable
        table.columns.day.form.type = value === 'ordinary' ? 'select' : 'hidden'
        // this.$set('')
        console.info(22, table.columns.day.form.type)
        // console.info(33, table.columns.day.options)
        // table.dialogFormList = value === 'ordinary' ? this.initList : this.advancedList
      }
    },
    computed: {
      freezeValues: {
        get () {
          return this.freezeFormValues
        },
        set (value) {
          this.$refs.freezeForm.formValues = value
        }
      }
    },
    mounted () {
      let result = expire()
      if (!result) {
        this.$router.push('/login')
      }
      if (this.tabName === 'freeze') {
        this.getFreezeData()
      }
    },
    // created () {
    //   this.columns.day.form
    // },
    methods: {
      changeTabEvent (value = this.tabList[0].name) {
        this.tabName = value
      },
      getFreezeData () {
        fetch({
          url: this.freezeResource
        }).then(res => {
          if (res) {
            this.freezeValues = res
          }
        })
      },
      getRelation (data) {
        this.treeData = treeFormat(data.countersAll, 'value')
      },
      setRequireParams (type, data) {
        const { timeArr, formValues } = data
        let resource = type === 'ordinary' ? '/nb/task' : '/nb/task/senior'
        let newValues = type === 'ordinary' ? {
          type: type,
          dayArray: formValues.day,
          paramArray: formValues.param,
          hour: timeArr[0],
          minute: timeArr[1],
          second: timeArr[2],
          operate: formValues.operate,
          copyTime: formValues.copyTime
        } : {
          type: type,
          cron: formValues.cron,
          paramArray: formValues.param,
          operate: formValues.operate
        }
        return {
          resource: resource,
          values: newValues
        }
      },
      changeSwitch (value) {
        this.actSwitchVal = value
        const table = this.$refs.copyDateTable
        // table.columns.day.form.type = value === 'ordinary' ? 'select' : 'hidden'
        table.dialogFormList = value === 'ordinary' ? this.initList : this.advancedList
        // console.info('-------:::', table.columns, table.columns.day.form.type)
      }
      // initSwitch (value) {
      //   const table = this.$refs.copyDateTable
      //   table.dialogFormList = value === 'ordinary' ? this.initList : this.advancedList
      // }
    }
  }
</script>
<style lang="sass" scoped>
  .main
    .main
      padding: 0!important
    .main-tabs
      height: 80vh!important
  .formBox
    width: 60%
    min-height: 500px
    margin: 20px auto
    .freezeForm
      .smart-timePicker
        width: 80%
</style>



// WEBPACK FOOTER //
// PeriodSetting.vue?72afd6be